import { Select } from "@etudescarre/ui";
import { Funnel as FunnelIcon, X as XIcon } from "@phosphor-icons/react";
import type { FilterDef, FilterValues } from "./types";

type ClasseurFilterBarProps = {
  filters: FilterDef[];
  activeFilters: FilterValues;
  onFilterChange: (filters: FilterValues) => void;
};

export function ClasseurFilterBar({
  filters,
  activeFilters,
  onFilterChange,
}: ClasseurFilterBarProps) {
  const hasActiveFilters = Object.values(activeFilters).some(
    (v) => v.length > 0,
  );

  function updateFilter(key: string, values: string[]) {
    onFilterChange({ ...activeFilters, [key]: values });
  }

  function clearFilters() {
    const cleared: FilterValues = {};
    for (const f of filters) {
      cleared[f.key] = [];
    }
    onFilterChange(cleared);
  }

  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-zinc-200 px-4 py-3 dark:border-zinc-700">
      <FunnelIcon size={18} className="shrink-0 text-zinc-500" />

      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
        {filters.map((filter) => (
          <div key={filter.key} className="w-44">
            <Select
              options={filter.options}
              value={activeFilters[filter.key] ?? []}
              onValueChange={({ value }) => updateFilter(filter.key, value)}
              placeholder={filter.label}
              multiple={filter.multiple ?? true}
            />
          </div>
        ))}
      </div>

      {hasActiveFilters && (
        <button
          type="button"
          onClick={clearFilters}
          className="flex items-center gap-1 rounded px-2 py-1 text-xs text-zinc-500 hover:bg-zinc-100 hover:text-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-200"
        >
          <XIcon size={14} />
          Effacer
        </button>
      )}
    </div>
  );
}
